import React, { useState } from 'react';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import './AutenticarDocumentos.css';
import NavbarLog from '../../../NavbarLog';
import axios from 'axios';

const AutenticarDocumentos = () => {
    const [documento, setDocumento] = useState('');
    const [resultado, setResultado] = useState(null);
    const [erro, setErro] = useState('');
    const [pdfFile, setPdfFile] = useState(null);


    const handleValidar = async () => {
        if (documento.trim() === '') {
            setErro('Campos com asterisco (*) são de preenchimento obrigatório. Verifique e tente novamente.');
            setResultado(null);
        } else {
            setErro('');
            try {
                // Tenta baixar o PDF diretamente
                const pdfResponse = await axios.get(
                    `${process.env.REACT_APP_API}/validate-document/?random_id=${documento}`,
                    { responseType: 'blob' }
                );
                if (pdfResponse.status === 200 && pdfResponse.data) {
                    const pdfBlob = new Blob([pdfResponse.data], { type: 'application/pdf' });
                    setPdfFile(URL.createObjectURL(pdfBlob));
                    setResultado(<span style={{
                        color: 'green',
                        WebkitTextStroke: '0.1px black',
                        fontWeight: 'bold'
                    }}>
                        O "CÓDIGO DE CONTROLE" DIGITADO NO CAMPO ACIMA, CORRESPONDE A UM DOCUMENTO EMITIDO PELO SISTEMA GEOCOHAB.
                    </span>);
                } else {
                    setResultado(<span style={{
                        color: 'red',
                        WebkitTextStroke: '0.1px black',
                        fontWeight: 'bold'
                    }}>
                        O "Código de controle" digitado no campo acima, não corresponde a um DOCUMENTO EMITIDO PELO SISTEMA GEOCOHAB.
                    </span>);
                    setPdfFile(null);
                }
            } catch (error) {
                setErro(<span style={{
                    color: 'red',
                    WebkitTextStroke: '0.1px black',
                    fontWeight: 'bold'
                }}>
                    Falha ao carregar o documento PDF. O "CÓDIGO DE CONTROLE" digitado não corresponde a um documento emitido pelo sistema GEOCOHAB.
                </span>);
                setResultado(null);
                setPdfFile(null);
            }
        }
    };

    const handleLimpar = () => {
        setDocumento('');
        setResultado(null);
        setErro('');
        setPdfFile(null);
        document.getElementById('file-input').value = null; // Reset the file input
    };

    const handlePdfUpload = async (event) => {
        const file = event.target.files
            ? event.target.files[0]
            : event.dataTransfer.files[0];

        if (file && file.type === 'application/pdf') {
            try {
                const formData = new FormData();
                formData.append('file', file);

                const response = await axios.post(
                    `${process.env.REACT_APP_API}/verificarpdf/`,
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    }
                );

                const resultadoApi = response.data?.[0];

                if (resultadoApi?.status === 'success') {
                    const objectUrl = URL.createObjectURL(file);
                    setPdfFile(objectUrl); // SÓ AQUI exibe o PDF
                    setResultado(<span style={{
                        color: 'green',
                        WebkitTextStroke: '0.1px black',
                        fontWeight: 'bold'
                    }}>
                        O DOCUMENTO ANEXADO CORRESPONDE A UM DOCUMENTO EMITIDO PELO SISTEMA GEOCOHAB.
                    </span>);
                } else {
                    setResultado(<span style={{
                        color: 'red',
                        WebkitTextStroke: '0.1px black',
                        fontWeight: 'bold'
                    }}>
                        'O PDF EM ANEXADO NO CAMPO ABAIXO, NÃO CORRESPONDE A UM DOCUMENTO EMITIDO PELO SISTEMA GEOCOHAB. TENTE NOVAMENTE OU ANEXE OUTRO PDF.'
                    </span>);
                    setPdfFile(null);
                }
            } catch (error) {
                setErro('Erro ao enviar o PDF para verificação. Tente novamente.');
                setPdfFile(null);
            }
        } else {
            setErro('Por favor, selecione um arquivo PDF válido.');
        }
    };


    const handleDivClick = () => {
        document.getElementById('file-input').click();
    };

    const handleDragOver = (event) => {
        event.preventDefault();
    };

    const handleDrop = (event) => {
        event.preventDefault();
        handlePdfUpload(event);
    };

    return (
        <div>
            <NavbarLog />
            <div className="AutenticarDocumentos">
                <Paper elevation={2} sx={{
                    maxHeight: "calc(100%-45px)",
                    width: pdfFile ? "50%" : "100%",
                    transition: "width 0.5s ease"
                }}
                    className='AutenticarDocumentos-container'>
                    <h1>Autenticar Documentos</h1>
                    <div className="tabs-line-action"></div>
                    <h2 className="Instructions"> Nesta página, você pode verificar a autenticidade de um documento emitido pelo nosso sistema. <br /> Para isso, insira o "Código de Controle" localizado no documento recebido. </h2>
                    <TextField
                        label="Código de controle de Autenticidade *"
                        variant="outlined"
                        fullWidth
                        value={documento}
                        onChange={(e) => setDocumento(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                handleValidar();
                            }
                        }}
                        className="input-field"
                        error={!!erro}
                        margin='normal'
                    />
                    {erro && <p className="erro">{erro}</p>}
                    <div className="button-group">
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleValidar}
                            className="validate-button"
                            style={{ marginRight: '0.1%' }}
                        >
                            Validar
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleLimpar}
                            className="clear-button"
                        >
                            Limpar
                        </Button>
                    </div>
                    <h2 className="Instructions">Você poderá obter do sistema 3 três respostas diferentes utilizando o Código de controle de Autenticidade.</h2>
                    <h2 className="Text-Intructions">1. O "Código de controle" digitado no campo acima, corresponde a um documento emitido pela SAI, e este ainda é válido. Neste caso você receberá na sua tela uma cópia fiel do documento em papel que lhe foi entregue, podendo assim confirmar a sua autenticidade.</h2>
                    <h2 className="Text-Intructions">2. O "Código de controle" digitado no campo acima, corresponde a um documento emitido pela SAI, mas este já perdeu a sua validade.</h2>
                    <h2 className="Text-Intructions">3. O "Código de controle" digitado no campo acima, não corresponde a um documento emitido pela SAI.</h2>
                    {resultado && <p className="resultado">{resultado}</p>}
                    <div
                        className="drag-drop-container"
                        onClick={handleDivClick}
                        onDragOver={handleDragOver}
                        onDrop={handleDrop}
                    >
                        <div className="drag-drop-content">
                            <i className="file-icon"></i>
                            <p><strong>Arraste seu documento ou selecione o PDF!</strong></p>
                            <input
                                type="file"
                                accept="application/pdf"
                                onChange={handlePdfUpload}
                                className="file-input"
                                id="file-input"
                            />
                        </div>
                    </div>
                </Paper>
                {pdfFile && (
                    <Paper sx={{
                        maxHeight: "calc(100%-45px)",
                        width: pdfFile ? "50%" : "100%",
                        transition: "width 0.5s ease"
                    }}
                        className='AutenticarDocumentos-container'>
                        <iframe
                            src={pdfFile}
                            title="PDF Viewer"
                            width="100%"
                            height="100%"
                            style={{ border: 'none', zIndex: 10001 }}
                        />
                    </Paper>
                )}
            </div>
        </div>
    );
};

export default AutenticarDocumentos;